/**
 * Utilitário universal para cópia de texto para a área de transferência (Clipboard).
 * Suporta navigator.clipboard moderno e fallback para document.execCommand('copy').
 *
 * @param {string} text - Texto a ser copiado.
 * @returns {Promise<boolean>} Retorna true se copiado com sucesso, false caso contrário.
 */
export const copyToClipboard = async (text) => {
  if (!text) return false;

  const content = typeof text === "string" ? text : String(text);

  try {
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(content);
      return true;
    }
  } catch (err) {
    console.warn("Clipboard API falhou, tentando fallback:", err);
  }

  try {
    const textArea = document.createElement("textarea");
    textArea.value = content;
    textArea.style.position = "fixed";
    textArea.style.left = "-9999px";
    textArea.style.top = "-9999px";
    textArea.style.opacity = "0";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    const successful = document.execCommand("copy");
    document.body.removeChild(textArea);
    return successful;
  } catch (err) {
    console.error("Fallback de cópia para clipboard falhou:", err);
    return false;
  }
};
